import { Actions, ActionsTypes } from '../actions/actions';
import { Customer } from '../models/customer';
import { CORE_ACTION, CoreActions, GetAVCCurrency } from '@uxdf/direct-shared-lib';

export interface State {
  isLoading: boolean;
  customerConfig: Customer;
}

/* eslint-disable */
function getInitialState(): State {
  return {
    isLoading: false,
    customerConfig: {
      is_decision_maker: false,
      is_product_orderer: false,
      is_financial_manager: false,
      is_avc_dashboards: false,
      is_avc_invoices: false,
      is_salesView: false,
      is_snow: false,
      avc_ta_currency: null,
      is_avc_credit_line_status: false
    } as Customer
  };
}

const initialState: State = getInitialState();

/* eslint-disable */
export function reducer(state = initialState, action: Actions & CoreActions): State {
  switch (action.type) {
    case CORE_ACTION.INIT_CUSTOMER_CONFIG: {
      return { ...state, isLoading: true };
    }
    case CORE_ACTION.SET_PO_CUSTOMER_CONFIG: {
      return {
        ...state,
        isLoading: true,
        customerConfig: { ...state.customerConfig, is_product_orderer: true }
      };
    }

    case CORE_ACTION.SET_FM_CUSTOMER_CONFIG: {
      return {
        ...state,
        isLoading: true,
        customerConfig: { ...state.customerConfig, is_financial_manager: true }
      };
    }

    case CORE_ACTION.SET_AVC_DASHBOARDS_CUSTOMER_CONFIG: {
      return {
        ...state,
        isLoading: true,
        customerConfig: { ...state.customerConfig, is_avc_dashboards: true }
      };
    }

    case CORE_ACTION.SET_AVC_INVOICES_CUSTOMER_CONFIG: {
      return {
        ...state,
        isLoading: true,
        customerConfig: { ...state.customerConfig, is_avc_invoices: true }
      };
    }

    case CORE_ACTION.SET_AVC_CREDIT_LINE_STATUS_CUSTOMER_CONFIG: {
      return {
        ...state,
        isLoading: true,
        customerConfig: { ...state.customerConfig, is_avc_credit_line_status: true }
      };
    }

    case CORE_ACTION.SET_SV_CUSTOMER_CONFIG: {
      return {
        ...state,
        isLoading: true,
        customerConfig: { ...state.customerConfig, is_salesView: true }
      };
    }

    case CORE_ACTION.SET_SNOW_CUSTOMER_CONFIG: {
      return {
        ...state,
        isLoading: true,
        customerConfig: { ...state.customerConfig, is_snow: true }
      };
    }

    case ActionsTypes.SetCustomerConfig: {
      return { ...state, isLoading: false, customerConfig: { ...action.payload.customerConfig, is_salesView: state.customerConfig.is_salesView, is_snow: state.customerConfig.is_snow}};
    }

    case ActionsTypes.ResetCustomerConfig: {
      return { ...initialState };
    }

    case CORE_ACTION.GET_AVC_TA_CURRENCY: {
      const currencyAction = action as GetAVCCurrency;
      return { 
        ...state, 
        isLoading: true,
        customerConfig: {
          ...state.customerConfig,
          avc_ta_currency: currencyAction.payload 
        }
      };
    }

    default:
      return state;
  }
}
